import BaseDropdown from './base';

export default class Kits extends BaseDropdown {
  menuSectionId = 'navigation-kits-container';
  menuOptionId = 'kits-navigation-link';
}
